import React, {useCallback, useContext, useEffect, useMemo, useState} from "react";
import {Form, Input, Radio, DatePicker, Select, Tooltip, Switch, Tag, Divider} from "antd";
import {
    Delete,
    RestoreFromTrash,
    Edit,
    FilterList,
    ExpandMore,
    ExpandLess,
    ErrorOutline,
    Search,
    DeleteForever,
    DeleteSweep
} from "@mui/icons-material";
import axios, {prepareAxiosParamsForStruts} from "../../../../common/axios";
import Button, {BUTTON_TYPE} from "../../../../common/Button";
import {UserContext} from "../../../../common/UserContext";
import CircularLoader from "../../../../common/CircularLoader";
import PopConfirm from "../../../../common/PopConfirm";
import GeneratePostTestIcon from "../../../../common/icons/GeneratePostTestIcon";
import AddPreTestIcon from "../../../../common/icons/AddPreTestIcon";
import {BrandContext} from "../../../../common/BrandContext";
import {EditableCell, EditableRow} from "./EditableTable";
import EditTest from "./EditTest";
import {HelpIcon} from "../../../../common/icons";
import {default as TooltipMUI} from "@mui/material/Tooltip";
import dayjs from "dayjs";
import {RECIPIENT} from "../enums";
import AssignDiagnosticTestDialog from "./AssignDiagnosticTestDialog";
import ShareTestsDialog from "../../ShareTestsDialog";
import CopyDiagnosticTestsDialog from "../../CopyDiagnosticTestsDialog";
import PrintTestDialog from "../../PrintTestDialog";
import AnswerKeyDialog from "../../AnswerKeyDialog";
import EditTestDialog from "../../EditTestDialog";
import ArchiveAllDialog from "../../ArchiveAllDialog";
import PreviewTestDialog from "../../PreviewTestDialog";
import CreateTestGroupDialog from "./CreateTestGroupDialog"
import CreatePreTestDialog from "./CreatePreTestDialog"
import CreatePostTestDialog from "./CreatePostTestDialog"
import {isFormMissingValues} from "../../../../common/utilityFunctions";
import TableAntD from "../../../../common/TableAntD";
import ShareIcon from "../../../../common/icons/ShareIcon";
import ShareTestFamilyDialog from "../../ShareTestFamilyDialog";
import {isCancel} from "axios";
import GenericDialog from "../../../../common/GenericDialog";
import PopconfirmWrapper from "../../../../common/PopconfirmWrapper";

const {Option} = Select,
    {RangePicker} = DatePicker;

const TestGroups = (props) => {
    const FILTER_OPTIONS = {
            'ALL': {
                label: 'All',
                value: 'ALL',
                publishStates: ['ARCHIVED', 'PUBLISHED', 'UNPUBLISHED'],
                meAuthor: true,
                allAuthor: true
            },
            'SCHOOL': {
                label: 'School',
            },
            'ARCHIVED': {label: 'Archived', labelLower: 'archived', value: 'ARCHIVED', publishStates: ['ARCHIVED']},
            'ACTIVE': {label: 'Active', value: 'ACTIVE', publishStates: ['PUBLISHED', 'UNPUBLISHED']},
            'ME': {label: 'Me', value: 'ME', publishStates: null, meAuthor: true, allAuthor: false},
            'SHARED': {label: 'Shared', value: 'SHARED', publishStates: null, meAuthor: false, allAuthor: true},
            'CUSTOM': {label: 'Custom', value: 'CUSTOM', publishStates: null},
        },
        INITIAL_FILTER_VALUES = {
            STATUS: FILTER_OPTIONS.ACTIVE,
            AUTHOR: FILTER_OPTIONS.ME,
            SHOW_DATE_RANGE: FILTER_OPTIONS.ALL
        },
        RECORDS = {
            FAMILY: {type: 'Family'},
            POST: {type: 'Post'},
            PRE_MID: {type: 'Pre/mid'},
            SHARED: {type: 'Shared', key: 'SHARED'},
        }

    const DEFAULT_RECIPIENT = RECIPIENT.SINGLE_CLASS;

    const {editAssignObj, refreshTestGroupId, setRefreshTestGroupId} = props,
        [isLoading, setLoading] = useState(false),
        [isMainLoading, setMainLoading] = useState(true),
        [triggerShareTestReload, setTriggerShareTestReload] = useState(null),
        [filterTemporary, setFilterTemporary] = useState({}),
        [isArchiveAllDialogOpen, setArchiveAllDialogOpen] = useState(false),
        [classIds, setClassIds] = useState([]),
        [studentIds, setStudentIds] = useState([]),
        [students, setStudents] = useState([]),
        [initialStudentIds, setInitialStudentIds] = useState([]),
        [isAssignDialogOpen, setAssignDialogOpen] = useState(false),
        [isShareDialogOpen, setShareDialogOpen] = useState(false),
        [isShareTestFamilyDialogOpen, setShareTestFamilyDialogOpen] = useState(false),
        [showDeleteAllForeverDialog, setShowDeleteAllForeverDialog] = useState(false),
        [isEditTestDialogOpen, setEditTestDialogOpen] = useState(false),
        [archiveBeforeDate, setArchiveBeforeDate] = useState(null),
        [selectedRowKeys, setSelectedRowKeys] = useState([]),
        [sharedTestIds, setSharedTestIds] = useState([]),
        [currentPageSharedTestIds, setCurrentPageSharedTestIds] = useState([]),
        [testGroupData, setTestGroupData] = useState([]),
        [testGroupDataObj, setTestGroupDataObj] = useState({}),
        [isCreatePreTestDialogOpen, setCreatePreTestDialogOpen] = useState(false),
        [isFilterActive, setFilterActive] = useState(false),
        [isCreatePostTestDialogOpen, setCreatePostTestDialogOpen] = useState(false),
        [isTableLoading, setIsTableLoading] = useState(false),
        [isShareTestTableLoading, setShareTestTableLoading] = useState(false),
        [isCreateTestGroupDialogOpen, setCreateTestGroupDialogOpen] = useState(false),
        [isCopyDialogOpen, setCopyDialogOpen] = useState(false),
        [isPrintTestDialogOpen, setPrintTestDialogOpen] = useState(false),
        [isAnswerKeyDialogOpen, setAnswerKeyDialogOpen] = useState(false),
        [isViewTestDialogOpen, setViewTestDialogOpen] = useState(false),
        [viewTestId, setViewTestId] = useState(null),
        [sharedSearchParams, setSharedSearchParams] = useState(),
        [sharedTestsTotal, setSharedTestsTotal] = useState(0),
        [showDateRange, setShowDateRange] = useState(false),
        [selectedTestGroupId, setSelectedTestGroupId] = useState(null),
        [shareTestFamilyId, setShareTestFamilyId] = useState(null),
        [shareTestFamilyName, setShareTestFamilyName] = useState(''),
        [expandedRowKeys, setExpandedRowKeys] = useState([]),
        [currentPage, setCurrentPage] = useState(1),
        [createTestType, setCreateTestType] = useState(null),
        [addQuestionsNow, setAddQuestionsNow] = useState(false),
        [createTestDescription, setCreateTestDescription] = useState(''),
        [singleSelected, setSingleSelected] = useState(false),
        [archiveOnly, setArchiveOnly] = useState(false),
        [openDialogDate, setDialogOpenDate] = useState(null),
        [startDate, setStartDate] = useState(dayjs()),
        [selectedRowsArchivable, setSelectedRowsArchivable] = useState(false),
        [selectedRowsUnarchivable, setSelectedRowsUnarchivable] = useState(false),
        [sharedTestSelected, setSharedTestSelected] = useState(false),
        [postTestSelected, setPostTestSelected] = useState(false),
        [multipleSelected, setMultipleSelected] = useState(false),
        [tableHeading, setTableHeading] = useState('Test families'),
        [searchValue, setSearchValue] = useState(''),
        [searchParams, setSearchParams] = useState({}),
        [selectedRows, setSelectedRows] = useState([]),
        [viewTestContent, setViewTestContent] = useState(''),
        [selectedSingleTest, setSelectedSingleTest] = useState({}),
        [formatValue, setFormatValue] = useState(editAssignObj.formatType.ASSESSMENT.val),
        [recipientState, setRecipientState] = useState(DEFAULT_RECIPIENT),
        [triggerEditTest, setTriggerEditTest] = useState(null),
        [currentTest, setCurrentTest] = useState(null),
        [filterForm] = Form.useForm(),
        [statusValue, setStatusValue] = useState(FILTER_OPTIONS.ACTIVE.value),
        [assignTestForm] = Form.useForm(),
        [shareTestForm] = Form.useForm(),
        [archiveAllForm] = Form.useForm(),
        [createPreTestForm] = Form.useForm(),
        [createPostTestForm] = Form.useForm(),
        [createTestGroupForm] = Form.useForm(),
        [useWizardForm] = Form.useForm(),
        brandConfig = useContext(BrandContext),
        {user} = useContext(UserContext),
        initialClassIds = user.classes.map((elem) => {
            return elem.classId
        }),
        pageSize = 5,
        UPDATE_ACTION = {ASSIGNED: 'Assigned', ARCHIVED: 'Archived', UNARCHIVED: 'Unarchived'},
        ASSIGNED_STATE = {
            ASSIGNED: {value: 'ASSIGNED', display: 'Assigned', lowerDisplay: 'assigned'},
            UNASSIGNED: {value: 'UNASSIGNED', display: 'Unassigned', lowerDisplay: 'unassigned'}
        },
        NO_EDIT_ARCHIVED_TOOLTIP = 'Edit is not available for archived tests.',
        NO_EDIT_PRE_MID_ASSIGNED_TOOLTIP = 'Edit is not available after test is assigned and in use, or post test is generated, please make a copy to edit the is assigned.',
        NO_EDIT_POST_ASSIGNED_TOOLTIP = 'Edit is not available after post test is assigned and in use.',
        NO_ADD_PRE_TEST_TOOLTIP = 'Pre tests can not be added after being assigned and started or the post test has been generated for the test family.',
        UNARCHIVE_TEST_GROUP_TOOLTIP = 'Unarchive Test Group to make changes.',
        NO_GENERATE_POST_TEST_TOOLTIP = 'All tests in the test family must have questions to generate a post-test.',
        POST_TEST_ALREADY_GENERATED_TOOLTIP = 'Post-test is already generated in this test family.',
        ARCHIVE_TEST_GROUP_WARNING = 'Archiving test family will also archive its tests',
        UNARCHIVE_TEST_GROUP_WARNING = 'Unarchiving test family will also unarchive its tests',
        GENERATE_POST_TEST_WARNING = 'You can not add pre/mid-tests to the test family once the post-test has been generated.',
        DELETE_TEST_GROUP_TOOLTIP = 'Archive test family',
        RESTORE_TEST_GROUP_TOOLTIP = 'Unarchive test family',
        SHARE_TEST_FAMILY = 'Share test family',
        DELETE_TEST_TOOLTIP = 'Archive test',
        DELETE_TEST_FOREVER_TOOLTIP = 'Delete test',
        DELETE_ALL_SHARED_TESTS_FOREVER_TOOLTIP = 'Delete all shared tests on current page',
        RESTORE_TEST_TOOLTIP = 'Unarchive test',
        MAIN_HELP_TOOLTIP = <div>
            <p>Create a family of pre- or mid-tests for a unit of work, and then set an auto-compiled post-test on that
                same unit of work.</p>
            <p>A ‘family’ can contain a single pre-test covering the whole unit, or any number of smaller tests (e.g.
                weekly topic tests).</p>
        </div>,
        NO_TEST_CREATED_YET_TOOLTIP = 'No tests have been created yet. Click +test button to add a pre/mid test.',
        NO_SHARED_TESTS_YET = 'No tests have been shared with you yet.',
        TEST_TYPE = {
            DIAGNOSTIC_PRE_TEST: 'DIAGNOSTIC_PRE_TEST',
            DIAGNOSTIC_POST_TEST: 'DIAGNOSTIC_POST_TEST'
        };

    useEffect(() => {
        if (refreshTestGroupId !== null) {
            const refreshData = testGroupData.filter((row) => row.testGroupId === refreshTestGroupId)[0];
            refreshData.testIds = [];
            loadTestsInTestGroup(refreshData, () => {
                expandRow(refreshTestGroupId)
            });
            setRefreshTestGroupId(null);
            //deselect rows because the selected keys are not up-to-date.
            if (statusValue !== FILTER_OPTIONS.ALL.value) {
                setSelectedRowKeys([]);
            }
        }
    }, [refreshTestGroupId]);

    const updatePostTestGenerated = (testGroupId) => {
        const refreshData = testGroupData.filter((row) => row.testGroupId === testGroupId)[0];
        refreshData.postTestGenerated = testGroupDataObj[testGroupId].postTestGenerated;
    }

    const refreshTestGroupFromPublishState = ((testGroupId, expanded, action) => {

        const refreshData = testGroupData.filter((row) => row.testGroupId === testGroupId)[0];
        refreshData.testIds = [];
        //if children are already loaded refresh the children
        if (!refreshData.loadChildrenOnExpand) {
            if (expanded) {
                loadTestsInTestGroup(refreshData, () => {
                    expandRow(refreshData.testGroupId)
                });
            } else {
                loadTestsInTestGroup(refreshData);
            }
        } else {
            updateTestGroupTestData(refreshData, null, action);
        }
        if (statusValue !== FILTER_OPTIONS.ALL.value) {
            setSelectedRowKeys([]);
        }
    });

    useEffect(() => {
        searchTestGroups();
    }, [searchParams]);

    const isInitialSearchParams = () => {
        if (showDateRange) {
            return false;
        }
        if (Object.keys(searchParams).length > 0) {
            if ((searchParams.name && searchParams.name !== '') || !searchParams.meAuthor || !searchParams.allAuthor || (searchParams.publishStates && !searchParams.publishStates.every((value, index) => value === FILTER_OPTIONS.ACTIVE.publishStates[index]))) {
                return false;
            }
        }

        return true;
    }

    const searchTestGroups = () => {
        setIsTableLoading(true);
        if (isInitialSearchParams()) {
            loadTestGroups();
        } else {
            loadTestGroupsWithFilters();
        }
        updateSharedTestGroupParams();
        collapseAllRows();
        setLoading(true);
    }

    const loadTestGroups = () => {
        setLoading(true);
        axios.get('/web/ui/test/loadTestGroups')
            .then(response => {
                if (response.data) {
                    const responseData = modifyTestGroupDataForTable(response.data);
                    setTestGroupData([...responseData]);
                }
                setTableHeading('Test families');
            }).catch((error) => {
            console.error('Error loading test groups: ', error);
        }).then(toggleEnableActions).finally(() => {
            setIsTableLoading(false);
            setLoading(false);
            setMainLoading(false);
        });
    }

    const updateSharedTestGroupParams = () => {
        if (searchParams.allAuthor === undefined || searchParams.allAuthor) {
            const params = JSON.parse(JSON.stringify(searchParams));
            params.meAuthor = undefined;
            params.allAuthor = undefined;
            params.name = undefined;
            setSharedSearchParams(params);
        }
    }

    const loadTestGroupsWithFilters = () => {
        setLoading(false);
        setMainLoading(false);
        if (searchParams.meAuthor === undefined || searchParams.meAuthor) {
            const params = JSON.parse(JSON.stringify(searchParams));
            params.testName = undefined;
            axios.post('/web/ui/test/searchTestsInTestGroupsWithFilter', params)
                .then(response => {
                    if (response.data) {
                        setTestGroupData(modifyTestGroupDataForTable(response.data));
                    }
                    if (searchValue) {
                        setTableHeading('Search results for \'' + searchValue + '\'');
                    } else {
                        setTableHeading('Test families');
                    }
                }).catch((error) => {
                if (error.response && error.response.data && error.response.data.message) {
                    if (searchValue) {
                        setTableHeading('Search results for \'' + searchValue + '\'');
                        setTableHeading('No test families found for \'' + searchValue + '\'');
                    } else {
                        setTableHeading('No test families found');
                    }
                    setTestGroupData([]);
                } else {
                    console.error('Error filtering test groups: ', error);
                }
            }).then(toggleEnableActions).finally(() => {
                setLoading(false);
                setIsTableLoading(false);
                setMainLoading(false);
            });
        } else {
            if (searchValue) {
                setTableHeading('Search results for \'' + searchValue + '\'');
                setTableHeading('No test families found for \'' + searchValue + '\'');
            } else {
                setTableHeading('No test families found');
            }
            setTestGroupData([]);
            setIsTableLoading(false);
        }
    }

    useEffect(() => {
        if (!isAssignDialogOpen) {
            setDialogOpenDate(null);
            assignTestForm.resetFields();
            setStudents([]);
            resetToDefaultRecipient();
        } else {
            setDialogOpenDate(dayjs());
            assignTestForm.setFieldValue('startDate', dayjs())
        }

    }, [isAssignDialogOpen]);

    useEffect(() => {
        if (!isCreatePreTestDialogOpen) {
            setAddQuestionsNow(false);
        }
    }, [isCreatePreTestDialogOpen]);

    // useEffect(()=>{
    //     setSecondaryActionsEnabled(selectedTests.length === 0)
    // },[selectedTests]);

    // const addRowToTable = ()=> {
    //     const testGroupDataArr = [...testGroupData];
    //     setTestGroupId(()=>{
    //         return testGroupId+1;
    //     });
    //     testGroupDataArr.push(createTestGroupRow(testGroupId,'name','details','created','description','status','postTest','type','action'));
    //     setTestGroupData(testGroupDataArr);
    // }

    useEffect(() => {
        const updateDataObj = {};
        testGroupData.forEach((testGroup) => {
            updateDataObj[testGroup.testGroupId] = testGroup;
        })
        setTestGroupDataObj(updateDataObj);
    }, [testGroupData]);

    const openCreateTestGroupDialog = () => {
        setCreateTestGroupDialogOpen(true);
    }

    const handleArchiveTestGroup = (record) => {
        archiveTestGroup(record.testGroupId, () => {
            if (FILTER_OPTIONS.ACTIVE.value === statusValue) {
                const newData = testGroupData.filter((item) => item.testGroupId !== record.testGroupId);
                setTestGroupData(newData);
                if (selectedRows.length > 0 && selectedRows.includes(record)) {
                    let tempSelectedRows = JSON.parse(JSON.stringify(selectedRows));
                    if (record.children.length > 0) {
                        record.children.forEach((child) => {
                            tempSelectedRows = tempSelectedRows.filter((row) => row.testId != child.testId);
                        });
                    }
                    tempSelectedRows = tempSelectedRows.filter((row) => row.testGroupId != record.testGroupId);
                    setSelectedRows(tempSelectedRows);
                }
            } else {
                record.archived = true;
                reloadUpdateTestGroup(record);//wait for testGroup update before loading tests into it
                refreshTestGroupFromPublishState(record.testGroupId, testGroupDataObj[record.testGroupId].expanded, UPDATE_ACTION.ARCHIVED);
            }
        });
    }

    const handleArchiveTest = (record) => {
        archiveTest(record.testId, () => {
            if (FILTER_OPTIONS.ACTIVE.value === statusValue) {
                removeTestInTable(record);
            }
            // const updateData = [...testGroupData];
            // setTestGroupData(updateData);
            setRefreshTestGroupId(record.testGroupId);
        });
    }

    const handleArchiveAllSharedTest = async () => {
        const testIdsForArchiving = currentPageSharedTestIds.toString();

        setShareTestTableLoading(() => {
            return true
        });

        axios.post('/web/ui/test/archiveTests', null, {
            params: {
                testIds: testIdsForArchiving,
            }
        }).catch((error) => {
            console.error('Error archiving tests: ', error);
        }).finally(() => {
            setShowDeleteAllForeverDialog(false)
            setShareTestTableLoading(false);
            reloadShareTestTable();
        });
    }

    const reloadShareTestTable = ()=>{
        setTriggerShareTestReload(new Date().getTime())
    }

    const handleUnarchiveTest = (record) => {
        unarchiveTest(record.testId, () => {
            // refreshTestGroupFromPublishState(record.testGroupId);
            setRefreshTestGroupId(record.testGroupId);
        });
    }
    const handleUnarchiveTestGroup = (record) => {
        unarchiveTestGroup(record.testGroupId, () => {
            // const testGroupRow = testGroupDataObj[record.testGroupId];
            if (FILTER_OPTIONS.ARCHIVED.value === statusValue) {
                const newData = testGroupData.filter((item) => item.testGroupId !== record.testGroupId);
                setTestGroupData(newData);
                if (selectedRows.length > 0 && selectedRows.includes(record)) {
                    let tempSelectedRows = JSON.parse(JSON.stringify(selectedRows));
                    if (record.children.length > 0) {
                        record.children.forEach((child) => {
                            tempSelectedRows = tempSelectedRows.filter((row) => row.testId != child.testId);
                        });
                    }
                    tempSelectedRows = tempSelectedRows.filter((row) => row.testGroupId != record.testGroupId);
                    setSelectedRows(tempSelectedRows);
                }
            } else {
                record.archived = false;
                refreshTestGroupFromPublishState(record.testGroupId, testGroupDataObj[record.testGroupId].expanded, UPDATE_ACTION.UNARCHIVED);

            }

        });
    }

    const unarchiveTestGroup = (testGroupId, callback) => {
        setIsTableLoading(true);
        axios.post('/web/ui/test/unarchiveTestGroup', null, {params: {testGroupId: testGroupId}})
            .then(response => {
                if (response.data.success) {
                    callback();
                }
            }).then(searchTestGroups).catch((error) => {
            console.error('Error unarchiving test group: ', error);
        }).finally(() => {
            setLoading(false);
            setIsTableLoading(false);
        });
    }

    const unarchiveTest = (testId, callback) => {
        setIsTableLoading(true);
        axios.post('/web/ui/test/unarchiveTest', null, {params: {testId: testId}})
            .then(response => {
                if (response.data.success) {
                    callback();
                }
            }).then(searchTestGroups).catch((error) => {
            console.error('Error archiving test: ', error);
        }).finally(() => {
            setLoading(false);
            setIsTableLoading(false);
        });
    }

    const removeTestInTable = (record) => {
        testGroupData.forEach((testGroup) => {
            if (testGroup.testGroupId === record.testGroupId) {
                testGroup.children = testGroup.children.filter((item) => item.testId !== record.testId);
                if (testGroup.children.length === 0) {
                    collapseRow(record.testGroupId);
                }
                if (selectedRows.length > 0 && selectedRows.includes(record)) {
                    setSelectedRows(selectedRows.filter((row) => row != record));
                }
                testGroup.postTestGenerated = false;
                updateTestGroupTestData(testGroup);
            }
        });
        setIsTableLoading(false);
    }

    const reloadUpdateTestGroup = () => {
        setTestGroupData(() => {
            return [...testGroupData]
        });
    }

    const updateTestGroupTestData = (testGroup, testIds, action) => {
        let preTotalTests = 0,
            totalTests = 0,
            totalQuestionsInGroup = 0,
            totalTestsAssigned = 0,
            allTestsHaveQuestions = true;

        if (testGroup.children !== undefined && testGroup.children.length > 0) {
            const children = [];
            testGroup.children.forEach((test) => {
                if (test.isPreTest) {
                    preTotalTests++;
                }
                totalTests++;

                //updates when assigning tests
                if (testIds && testIds.length > 0 && testIds.includes(String(test.testId)) && action === UPDATE_ACTION.ASSIGNED) {
                    test.assigned = true;
                    test.status = ASSIGNED_STATE.ASSIGNED.lowerDisplay + (test.started ? '\nin use' : '\nnot in use');
                }

                if (test.assigned) {
                    totalTestsAssigned++;
                }
                totalQuestionsInGroup += test.total;
                if (test.total === 0) {
                    allTestsHaveQuestions = false;
                }
                children.push(test);
            });
            testGroup.children = children;
        } else {
            allTestsHaveQuestions = false;
        }
        testGroup.totalTestsAssigned = totalTestsAssigned;


        if (statusValue === FILTER_OPTIONS.ALL.value) {
            if (action === UPDATE_ACTION.ARCHIVED || action === UPDATE_ACTION.UNARCHIVED) {
                testGroup.postTest = action === UPDATE_ACTION.UNARCHIVED ? 'Generated' : 'Not generated';
                testGroup.archived = action === UPDATE_ACTION.ARCHIVED;
            } else {
                testGroup.postTest = testGroupDataObj[testGroup.testGroupId].postTestGenerated + '' === 'true' ? 'Generated' : 'Not generated';
                testGroup.archived = testGroupDataObj[testGroup.testGroupId].archived;
            }
        } else {
            testGroup.totalQuestionsInGroup = totalQuestionsInGroup;
            testGroup.allTestsHaveQuestions = allTestsHaveQuestions;
            testGroup.details = totalTests > 0 ? preTotalTests + ' pre/mid-tests\n' + totalQuestionsInGroup + ' questions total' : 'No tests created';
            testGroup.totalTests = totalTests;
        }

        testGroup.status = testGroup.totalTests === 0 ? 'No tests assigned' : testGroup.totalTestsAssigned + '/' + testGroup.totalTests + ' assigned' + (testGroup.archived ? ' (' + FILTER_OPTIONS.ARCHIVED.labelLower + ')' : '');
        testGroup.updated = new Date().getTime();
        reloadTestGroupWithRecord(testGroup);
    }

    const updateTestGroup = (testGroup) => {
        setIsTableLoading(true);
        axios.post('/web/ui/test/updateTestGroup', {
            testGroupId: testGroup.testGroupId,
            testGroupName: testGroup.name,
            description: testGroup.description
        })
            .then(response => {
                // callback();
                setLoading(false);
                setIsTableLoading(false);
            }).catch((error) => {
            console.error('Error updating test group: ', error);
            setLoading(false);
            setIsTableLoading(false);
        });
    }

    const updateTest = (test) => {
        setIsTableLoading(true);
        axios.post('/web/ui/test/updateTest', {testId: test.testId, name: test.name, description: test.description})
            .then(response => {
                // callback();
                setLoading(false);
                setIsTableLoading(false);
            }).catch((error) => {
            console.error('Error updating test: ', error);
            setLoading(false);
            setIsTableLoading(false);
        });
    }

    const archiveTestGroup = (testGroupId, callback) => {
        setIsTableLoading(true);
        axios.post('/web/ui/test/archiveTestGroup', null, {params: {testGroupId: testGroupId}})
            .then(response => {
                if (callback && typeof callback === 'function') {
                    callback();
                }
                setLoading(false);
                setIsTableLoading(false);
            }).catch((error) => {
            console.error('Error archiving test group: ', error);
            setLoading(false);
            setIsTableLoading(false);
        });
    }

    const archiveTestGroupsBeforeDate = async () => {
        setIsTableLoading(true);
        axios.post('/web/ui/test/archiveTestGroupsBeforeDate', null, {params: {date: archiveBeforeDate}})
            .then(response => {
                setArchiveAllDialogOpen(false);
                hideArchivedTestGroups();
                return Promise.resolve();
            }).then(searchTestGroups).catch((error) => {
            return Promise.reject(error);
        }).finally(() => {
            setIsTableLoading(false);
        });
    }

    const hideArchivedTestGroups = () => {
        if (statusValue === FILTER_OPTIONS.ALL.value) {
            const beforeDate = new Date(archiveBeforeDate);
            beforeDate.setHours(0, 0, 0, 0);
            const updateData = testGroupData.filter((testGroup) => testGroup.createDate <= beforeDate.getTime() && !testGroup.archived);
            updateData.forEach((testGroup) => {
                testGroup.archived = true;
                if (testGroup.children) {
                    testGroup.children.forEach((test) => {
                        test.archived = true;
                    })
                }
                refreshTestGroupFromPublishState(testGroup.testGroupId, testGroup.expanded);
            });
            setTestGroupData(updateData);
        } else {
            const beforeDate = new Date(archiveBeforeDate);
            beforeDate.setHours(0, 0, 0, 0);
            const updateData = testGroupData.filter((testGroup) => testGroup.createDate >= beforeDate.getTime());
            setTestGroupData(updateData);
            setArchiveBeforeDate(null);
        }
    }

    const openPreTestDialog = (record) => {
        setCreateTestType(TEST_TYPE.DIAGNOSTIC_PRE_TEST);
        // setCreateTestDescription('Add a test to this test-family.');
        setCreatePreTestDialogOpen(true);
        // setCreateTestTitle();
        setSelectedTestGroupId(record.testGroupId);
    }

    const openPostTestDialog = (record) => {
        setCreateTestType(TEST_TYPE.DIAGNOSTIC_POST_TEST);
        setCreatePostTestDialogOpen(true);
        setSelectedTestGroupId(record.testGroupId);
    }

    const onCreateTestGroup = async () => {
        const fieldValues = createTestGroupForm.getFieldsValue(),
            testGroupName = fieldValues.testGroupName,
            description = fieldValues.description;

        if (testGroupName === '' || testGroupName === undefined) {
            createTestGroupForm.validateFields();
            return Promise.reject(new Error('Test group name is invalid'));
        }

        setLoading(true);
        setIsTableLoading(true);
        await axios.post('/web/ui/test/createTestGroup', {testGroupName: testGroupName, description: description})
            .then(response => {
                setLoading(false);
                setIsTableLoading(false);
                setCreateTestGroupDialogOpen(false);
                createTestGroupForm.resetFields();
                const updateData = [...testGroupData];
                updateData.unshift(modifyTestGroupDataForTable([response.data])[0]);
                setTestGroupData(updateData);
                // setCurrentPage(Math.floor((updateData.length)/(pageSize+1))+1);
                setCurrentPage(1);
            }).catch((error) => {
                setIsTableLoading(false);
                console.error('Error creating test group: ', error);
            });
    }

    const onCreatePreTest = async () => {
        const fieldValues = createPreTestForm.getFieldsValue();
        const ignoreFields = ['testDescription'];
        if (!fieldValues.addQuestionsNow) {
            ignoreFields.push('useWizard');
        }
        if (isFormMissingValues(fieldValues, ignoreFields)) {
            createPreTestForm.validateFields();
            return Promise.reject('Form is missing values');
        }
        onCreateTest(fieldValues, () => {
            setCreatePreTestDialogOpen(false);
            createPreTestForm.resetFields();
        });
    }

    const onCreatePostTest = async () => {
        const fieldValues = createPostTestForm.getFieldsValue();
        if (isFormMissingValues(fieldValues, ['testDescription'])) {
            createPostTestForm.validateFields();
            return Promise.reject('Form is missing values');
        }
        onCreateTest(fieldValues, () => {
            setCreatePostTestDialogOpen(false);
            createPostTestForm.resetFields();
        });
    }

    const onCreateTest = (fieldValues, dialogCallback) => {
        setIsTableLoading(true);
        const record = testGroupData.filter(item => item.testGroupId === selectedTestGroupId)[0];
        axios.post('/web/ui/test/createTestInTestGroup', {
            name: fieldValues.testName,
            description: fieldValues.testDescription,
            testGroupId: selectedTestGroupId,
            testPurpose: createTestType,
            diagnosticTest: true
        })
            .then(response => {
                if (response.data) {
                    setCurrentTest(null);
                    if (createTestType === TEST_TYPE.DIAGNOSTIC_PRE_TEST && fieldValues.addQuestionsNow) {
                        addTestToGroup(record, response.data, () => {
                            props.setUseEditWizard(fieldValues.useWizard);
                            props.setEditTest(new EditTest(response.data.testId, response.data.testGroupId, response.data.name, response.data.description));
                            setTriggerEditTest(new Date().getTime());
                        });
                    } else {
                        //Only update table data if it doesn't change tab to edit test;
                        record.postTestGenerated = createTestType === TEST_TYPE.DIAGNOSTIC_POST_TEST;
                        addTestToGroup(record, response.data, () => {
                            setRefreshTestGroupId(record.testGroupId);
                        });
                    }
                }
                if (dialogCallback && typeof dialogCallback === 'function') {
                    dialogCallback();
                }
                setIsTableLoading(false);
                return Promise.resolve();
            }).catch((error) => {
            if (error.response && error.response.data && error.response.data.message) {
                displayToastMessage('Error creating test', error.response.data.message, 'warning', undefined, 10000);
            } else {
                displayToastMessage('Error creating test', 'General server error.', 'error', undefined, 10000);
                console.error('Error: ', error);
            }
            setIsTableLoading(false);
            return Promise.reject(error);
        });
    }

    useEffect(() => {
        if (currentTest !== null) {
            props.setEditTest(currentTest);
        }
    }, [triggerEditTest]);

    const GeneratePostTestComponent = (props) => {
        const {testGroup} = props;

        return useMemo(() => {
            return (
                <>
                    {(testGroup.allTestsHaveQuestions && !testGroup.postTestGenerated && testGroup.totalTests > 0 && testGroup.totalQuestionsInGroup > 0 && !testGroup.archived) ?
                        <GeneratePostTestIcon tooltipprops={{title: 'Generate post-test', arrow: false}} iconprops={{
                            viewBox: '0 0 48 48',
                            style: {cursor: 'pointer', marginTop: '2px'}, width: 38,
                            height: 38, onClick: () => {
                                // if(testGroup.allTestsHaveQuestions){
                                openPostTestDialog(testGroup);
                                // } else {
                                //     displayToastMessage('All tests in Test Family have to contain questions', '', 'warning', undefined, 10000);
                                // }
                            }
                        }}/>
                        : <GeneratePostTestIcon trigger={['hover', 'click']} tooltipprops={{
                            title: testGroup.archived ? UNARCHIVE_TEST_GROUP_TOOLTIP : testGroup.postTestGenerated ? POST_TEST_ALREADY_GENERATED_TOOLTIP : NO_GENERATE_POST_TEST_TOOLTIP,
                            arrow: false
                        }}
                        iconprops={{
                            viewBox: '0 0 48 48',
                            style: {marginTop: '2px', fill: 'grey'},
                            width: 38,
                            height: 38
                        }}/>}
                </>)
        }, [testGroup.updated])
    }

    const defaultColumns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            editable: true
        },
        {
            title: 'Test details',
            dataIndex: 'details',
            key: 'details',
            render: (text, value) => {
                let text0,
                    text1;
                if (text && text.split('\n')[0]) {
                    text0 = text.split('\n')[0];
                }
                if (text && text.split('\n')[1]) {
                    text1 = text.split('\n')[1];
                }
                return <>
                    <div>{text0}</div>
                    <div>{text1}</div>
                    {value.shareDate && <Tooltip trigger={['hover', 'click']} title={'Shared by '+value.previousAuthorName}><Tag color={'geekblue'}>shared</Tag></Tooltip>}
                </>
            }
        },
        {
            title: 'Created by',
            dataIndex: 'created',
            key: 'created',
            render: (value,row) => {
                if(row.shareDate){
                    return (<>
                        <div>{row.previousAuthorName}</div>
                        <div>{user.dateFormat.format(row.createDate)}</div>
                        <div>Shared on</div>
                        <div>{user.dateFormat.format(row.shareDate)}</div>
                    </>)
                }
                return (<>
                    <div>{row.authorName}</div>
                    <div>{user.dateFormat.format(row.createDate)}</div>
                </>)
            }
            // width: 240,
            // ellipsis: true
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            editable: true
            // width: 240,
            // ellipsis: true
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text) => {
                if (text.includes('\n')) {
                    let text0,
                        text1;
                    if (text && text.split('\n')[0]) {
                        text0 = text.split('\n')[0];
                    }
                    if (text && text.split('\n')[1]) {
                        text1 = text.split('\n')[1];
                    }
                    return <div className={'flex'}>
                        <div className={'flexColumn'}>
                            <div>{text0}</div>
                            <div>({text1})</div>
                        </div>
                    </div>
                } else {
                    return <>{text}</>
                }

            }
            // width: 240,
            // ellipsis: true
        },
        {
            title: 'Post-test',
            dataIndex: 'postTest',
            key: 'postTest'
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type'
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            // width: 240,
            // ellipsis: true
            render: (_, record) => {
                return (<div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    {record.type === RECORDS.FAMILY.type &&
                        <>
                            {(record.postTestGenerated || record.archived) ? (
                                <AddPreTestIcon trigger={['hover', 'click']} tooltipprops={{
                                    title: record.archived ? UNARCHIVE_TEST_GROUP_TOOLTIP : NO_ADD_PRE_TEST_TOOLTIP,
                                    arrow: false
                                }} iconprops={{
                                    style: {fill: 'grey'},
                                    viewBox: '0 0 48 48',
                                    width: 38,
                                    height: 38
                                }}/>) : (
                                <AddPreTestIcon tooltipprops={{title: 'Add pre/mid test', arrow: false}} iconprops={{
                                    viewBox: '0 0 48 48',
                                    style: {cursor: 'pointer'}, width: 38, height: 38, onClick: () => {
                                        openPreTestDialog(record);
                                    }
                                }}/>
                            )}
                            <GeneratePostTestComponent testGroup={record}/>
                            {user.demoOrTestSchool &&
                                <Tooltip trigger={['hover', 'click']} title={SHARE_TEST_FAMILY}>
                                    <ShareIcon style={{cursor: 'pointer'}} onClick={()=>{openShareTestFamilyDialog(record)}}/>
                                </Tooltip>
                            }
                            {record.archived ?
                                (<PopConfirm title={<span>Archive selected Test Family?</span>} placement="left"
                                             description={UNARCHIVE_TEST_GROUP_WARNING}
                                             okText='Unarchive' onConfirm={() => handleUnarchiveTestGroup(record)}>
                                    <Tooltip title={RESTORE_TEST_GROUP_TOOLTIP} arrow={false}><RestoreFromTrash
                                        style={{cursor: 'pointer', color: 'limegreen', fontSize: '24px'}}/>
                                    </Tooltip>
                                </PopConfirm>) :
                                (<PopConfirm title={<span>Archive selected Test Family?</span>} placement="left"
                                             description={ARCHIVE_TEST_GROUP_WARNING}
                                             okText='Archive' onConfirm={() => handleArchiveTestGroup(record)}>
                                    <Tooltip title={DELETE_TEST_GROUP_TOOLTIP} arrow={false}><Delete
                                        style={{cursor: 'pointer', color: 'red', fontSize: '24px'}}/></Tooltip>
                                </PopConfirm>)
                            }

                        </>
                    }
                    {(record.type === RECORDS.POST.type || record.type === RECORDS.PRE_MID.type) &&
                        <>
                            {record.editable &&
                                <Tooltip title={"Edit test"}><Edit onClick={() => handleEditTest(record)} style={{
                                    cursor: 'pointer',
                                    fontSize: '24px'
                                }}/></Tooltip>}
                            {!record.editable && <Tooltip trigger={['hover', 'click']}
                                                          title={record.archived ? NO_EDIT_ARCHIVED_TOOLTIP : (record.testPurpose === TEST_TYPE.DIAGNOSTIC_PRE_TEST ? NO_EDIT_PRE_MID_ASSIGNED_TOOLTIP : NO_EDIT_POST_ASSIGNED_TOOLTIP)}><Edit
                                style={{color: 'grey', fontSize: '24px'}}/></Tooltip>}
                            {!record.archived &&
                                <PopConfirm title={<span>Archive selected Test?</span>} placement="left"
                                            okText='Archive'
                                            onConfirm={() => handleArchiveTest(record)}>
                                    <Tooltip title={DELETE_TEST_TOOLTIP} arrow={false}><Delete
                                        style={{cursor: 'pointer', fontSize: '24px'}}/></Tooltip>
                                </PopConfirm>}
                            {(record.archived && !record.postTestGenerated) &&
                                <PopConfirm title={<span>Unarchive selected Test?</span>} placement="left"
                                            okText='Unarchive'
                                            onConfirm={() => handleUnarchiveTest(record)}>
                                    <Tooltip title={RESTORE_TEST_TOOLTIP}><RestoreFromTrash
                                        style={{cursor: 'pointer', color: 'limegreen', fontSize: '24px'}}/></Tooltip>
                                </PopConfirm>}
                            {(record.archived && record.postTestGenerated) &&
                                <Tooltip trigger={['hover', 'click']} placement={'left'}
                                         title={'Can not unarchive test where post-test is already generated.'}><RestoreFromTrash
                                    style={{color: 'grey', fontSize: '24px'}}/></Tooltip>}
                        </>
                    }
                </div>)
            }
        }
    ]

    const testGroupColumns = defaultColumns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave,
                handleEditTest,
                handleViewTest
            }),
        };
    });

    const sharedTestColumns = useMemo(()=>{
        const cols = [...testGroupColumns];
        cols.splice(7,1);
        cols.splice(5,1);

        cols.push({
            title:(
                    <div className={'flexAlignCentre smallGap'}><span>Action</span><Button disabled={sharedTestsTotal === 0} className={'smallGap'} type={BUTTON_TYPE.TEXT} onClick={()=>{setShowDeleteAllForeverDialog(true)}}>
                    <DeleteSweep style={{cursor: 'pointer', fontSize: '24px', color:sharedTestsTotal === 0?'darkgrey':'red'}} />
                    </Button>
                </div>
            ),
            dataIndex:'action',
            render: (_, record) => {
                return (<div className={'flexAlignCentre'}>
                    <Button type={BUTTON_TYPE.TEXT} onClick={()=>{setSharedTestSelected(true);setSelectedSingleTest(record);setCopyDialogOpen(true)}}>
                        Move into test family
                    </Button>
                    <PopconfirmWrapper childrenIsReact={true} title={<span>Delete shared Test?</span>}
                                okText='Archive'
                                onConfirm={() => archiveShareTest(record.testId)}>
                        <Tooltip title={DELETE_TEST_FOREVER_TOOLTIP} arrow={false}><Button type={BUTTON_TYPE.TEXT}><DeleteForever
                            style={{cursor: 'pointer', fontSize: '24px', color:'red'}}/></Button></Tooltip>
                    </PopconfirmWrapper>
                </div>);
            }
        });
        return cols;
    },[])




    const handleViewTest = (record) => {
        setViewTestId(record.testId);
        setViewTestDialogOpen(true);
    }

    const handleEditTest = (record) => {
        setCurrentTest(new EditTest(record.testId, record.testGroupId, record.name, record.description));
        if (record.isPreTest && record.total === 0) {
            setEditTestDialogOpen(true);
            if (useWizardForm.getFieldValue('useWizard') === undefined) { //sets default useWizard on first open
                props.setUseEditWizard(true);
            }
        } else {
            props.setUseEditWizard(false);
            setTriggerEditTest(new Date().getTime());
        }
    }

    const handleSave = (row) => {

        if (row.savedData === row.name + row.description) {
            return;
        }

        if (row.type === RECORDS.FAMILY.type) {
            updateTestGroup(row);
        } else {
            updateTest(row);
        }
        row.savedData = row.name + row.description;

        const newData = [...testGroupData],
            index = newData.findIndex((item) => row.testGroupId === item.testGroupId),
            item = newData[index];
        if (row.type === RECORDS.FAMILY.type) {
            newData.splice(index, 1, {
                ...item,
                ...row,
            });
        } else {
            const childIndex = item.children.findIndex((item) => row.testId === item.testId),
                childItem = item.children[childIndex];
            item.children.splice(childIndex, 1, {
                ...childItem,
                ...row,
            });
        }

        setTestGroupData(newData);
    };

    const getTestIdsFromTestGroups = async (callback) => {
        const ids = getSelectedTestAndGroupIds(),
            testGroupIds = ids.testGroupIds.length > 0 ? ids.testGroupIds.toString() : ids.testGroupIds,
            testIds = ids.testIds.length > 0 ? ids.testIds.toString() : ids.testIds,
            mergedTestGroupIds = ids.mergedTestGroupIds;

        if (testGroupIds === null || testGroupIds.length === 0) {
            await callback(ids.testIds, mergedTestGroupIds);
        } else {
            await axios.get('/web/ui/test/getTestIdsFromTestGroups', {
                params: {
                    testGroupIds: testGroupIds,
                    testIds: testIds
                }
            })
                .then(async (response) => {
                    if (response.data) {
                        if (callback && typeof callback === 'function') {
                            await callback(response.data, mergedTestGroupIds);
                        }
                    }
                }).catch((error) => {
                    console.error('Error getting test ids from test groups: ', error);
                });
        }
    }

    const collapseRow = (testGroupId) => {
        testGroupData.forEach((row) => {
            if (row.testGroupId === testGroupId) {
                row.expanded = false;
                setExpandedRowKeys(expandedRowKeys.filter((key) => key !== testGroupId + ''));
            }
        });
        setIsTableLoading(false);
    }

    const collapseAllRows = () => {
        if (expandedRowKeys.length > 0) {
            testGroupData.forEach((row) => {
                row.expanded = false;
            });
            setExpandedRowKeys([]);
        }
    }

    const expandRow = (testGroupId, testData) => {
        let tempSelectedRows = JSON.parse(JSON.stringify(selectedRows));
        testGroupData.forEach((row) => {
            if (parseInt(row.testGroupId) === parseInt(testGroupId)) {
                row.expanded = true;
                if (testData) {
                    if (row.children) {
                        row.children.push(testData);
                    } else {
                        row.children = [testData];
                    }
                    row.totalTests = row.children.length;
                    row.totalQuestionsInGroup += testData.total;
                    if (testData.isPreTest) row.preTotalTests++;
                }
                if (!expandedRowKeys.includes(testGroupId)) {
                    setExpandedRowKeys([...expandedRowKeys, testGroupId + '']);
                }
                if (selectedRows.length > 0 && selectedRows.includes(row)) {
                    if (row.children.length > 0) {
                        row.children.forEach((child) => {
                            if (!tempSelectedRows.includes(child)) {
                                tempSelectedRows.push(child);
                            }
                        });
                    }
                    tempSelectedRows = tempSelectedRows.filter((selectedRow) => parseInt(selectedRow.testGroupId) != parseInt(testGroupId));
                    tempSelectedRows.push(row);
                }
            }
            setIsTableLoading(false);
        });
        const updateData = [...testGroupData];
        setTestGroupData(updateData);
        setSelectedRows(tempSelectedRows);
    }

    // useEffect(()=>{
    //
    //
    // },[expandedRowKeys]);

    const onTestGroupExpand = (record, fromSelect) => {
        if (record.expanded) {
            if (fromSelect) {
                return;
            }
            if (record.key === RECORDS.SHARED.key) {
                setExpandedRowKeys(expandedRowKeys.filter((key) => key !== record.key));
            } else {
                collapseRow(record.testGroupId);
            }
        } else {
            if (record.loadChildrenOnExpand) {
                loadTestsInTestGroup(record, () => {
                    expandRow(record.testGroupId)
                });
            } else {
                    expandRow(record.testGroupId);
            }
        }
    }

    const loadTestsInTestGroup = (record, callback) => {
        const publishStates = filterForm.getFieldValue('status') ? FILTER_OPTIONS[filterForm.getFieldValue('status')].publishStates : FILTER_OPTIONS.ACTIVE.publishStates;
        axios.post('/web/ui/test/loadTestsInTestGroupByIds', record.testIds, {
            params: {
                testGroupId: record.testGroupId,
                publishStates: publishStates.toString()
            }
        })
            .then(response => {
                if (response.data) {
                    record.children = modifyTestDataForTable(response.data, record.testGroupId);
                    record.loadChildrenOnExpand = false;

                    let totalGroupQuestions = 0;
                    record.children.forEach((test) => {
                        record.testIds.push(test.testId);
                        totalGroupQuestions += test.total;
                    });
                    record.totalQuestionsInGroup = totalGroupQuestions;
                    updateTestGroupTestData(record);
                    if (callback && typeof callback === 'function') {
                        callback();
                    }
                }
                setIsTableLoading(false);
            }).catch((error) => {
            setIsTableLoading(false);
            console.error('Error loading tests: ', error);
        });
        setIsTableLoading(true);
    }

    const reloadTestGroupWithRecord = (record) => {
        const updateData = [...testGroupData];
        for (let i = 0; i < updateData.length; i++) {
            if (updateData[i].testGroupId === record.testGroupId) {
                updateData[i] = {...record};
                break;
            }
        }
        setTestGroupData([...updateData]);
    }

    const modifyTestDataForTable = (newTestData, testGroupId, isShared) => {
        let i = 0;

        const map = newTestData.map(test => ({
            ...test,
            key: isShared ? 'shared-'+test.testId : testGroupId+'-'+test.testId,
            name: test.name,
            description: test.description,
            details: test.total + ' questions total',
            created: (test.clonedTestOwner !== undefined ? test.clonedTestOwner : test.ownedBy) + '\n' + user.dateFormat.format(test.createDate),
            status: (test.assigned ? ASSIGNED_STATE.ASSIGNED.lowerDisplay : ASSIGNED_STATE.UNASSIGNED.lowerDisplay + (test.publishState === FILTER_OPTIONS.ARCHIVED.value ? ' (' + FILTER_OPTIONS.ARCHIVED.labelLower + ')' : '')) + (test.assigned ? (test.started ? '\nin use' : '\nnot in use') : ''),
            postTest: '',
            type: test.testPurpose === TEST_TYPE.DIAGNOSTIC_PRE_TEST ? RECORDS.PRE_MID.type : RECORDS.POST.type,
            isPreTest: test.testPurpose === TEST_TYPE.DIAGNOSTIC_PRE_TEST,
            testPurpose: test.testPurpose,
            testGroupId: testGroupId,
            testId: test.testId
        }));
        return map;
    }

    const modifyTestGroupDataForTable = (newTestGroupData) => {
        return newTestGroupData.map(row => ({
            ...row,
            testIds: row.testIds,
            createDate: row.createDate,
            postTestGenerated: row.postTestGenerated,
            name:row.testGroupName,
            description: row.description,
            key: row.testGroupId + '',
            details: row.totalTests > 0 ? row.preTotalTests + ' pre/mid-test\n' + row.totalQuestionsInGroup + ' questions total' : 'No tests created',
            created: (row.authorName + '\n' + user.dateFormat.format(row.createDate)) + (row.shareDate !== undefined ? '\n shared\n'+user.dateFormat.format(row.shareDate) + ' by '+row.previousAuthorName : ''),
            status: row.totalTests === 0 ? 'No tests assigned' : row.totalTestsAssigned + '/' + row.totalTests + ' assigned' + (row.publishState === FILTER_OPTIONS.ARCHIVED.value ? ' (' + FILTER_OPTIONS.ARCHIVED.labelLower + ')' : ''),
            postTest: row.postTestGenerated + '' === 'true' ? 'Generated' : 'Not generated',
            type: row.testGroupCode === 'DIAGNOSTIC_GROUP' ? RECORDS.FAMILY.type : '',
            children: [],
            loadChildrenOnExpand: row.totalTests > 0,
            expanded: false,
            testGroupId: row.testGroupId,
            totalTests: row.totalTests,
            updated: new Date().getTime()
            // totalQuestionsInGroup: row.totalQuestionsInGroup
        }));
    }

    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const archiveTest = (testId, callback) => {
        setIsTableLoading(() => {
            return true
        });
        axios.post('/web/ui/test/archiveTest', null, {params: {testId: testId}})
            .then(response => {
                callback();
            }).then(searchTestGroups).catch((error) => {
            console.error('Error archiving test: ', error);
        }).finally(() => {
            setIsTableLoading(false);
        });
    }

    const archiveShareTest = useCallback((testId) => {
        setShareTestTableLoading(() => {
            return true
        });
        axios.post('/web/ui/test/archiveTest', null, {params: {testId: testId}})
            .then(response => {
                if(response.data.success){
                    displayToastMessage('Shared Test archived successfully', '', 'success', undefined, 10000);
                    reloadShareTestTable();
                }else{
                    displayToastMessage('Error archiving Shared Test', '', 'error', undefined, 10000);
                }
            }).catch((error) => {
                displayToastMessage('Error archiving Shared Test', '', 'error', undefined, 10000);
                console.error('Error archiving test: ', error);
        }).finally(() => {
            setShareTestTableLoading(false);
        });
    },[]);

    const archiveTests = () => {
        setIsTableLoading(() => {
            return true
        });
        if (FILTER_OPTIONS.ACTIVE.value === statusValue) {
            setSelectedRowKeys(() => {
                return [];
            });
        }

        const ids = getSelectedTestAndGroupIdsByArchived(false),
            testIds = ids.testIds,
            testGroupIds = ids.testGroupIds;
        axios.post('/web/ui/test/archiveTests', null, {
            params: {
                testIds: testIds.toString(),
                testGroupIds: testGroupIds.toString()
            }
        })
            .then(response => {
                const testGroupRefreshIds = [];
                selectedRows.forEach((row) => {
                    if (row.type !== RECORDS.FAMILY.type && FILTER_OPTIONS.ACTIVE.value === statusValue) {
                        removeTestInTable(row);
                    } else {
                        row.archived = true;
                        if (row.testPurpose === TEST_TYPE.DIAGNOSTIC_POST_TEST) {
                            testGroupDataObj[row.testGroupId].postTestGenerated = false;
                        }
                        if (!testGroupRefreshIds.includes(row.testGroupId)) {
                            testGroupRefreshIds.push(row.testGroupId);
                        }
                    }
                });

                if (statusValue === FILTER_OPTIONS.ALL.value) {
                    testGroupRefreshIds.forEach((testGroupId) => {
                        refreshTestGroupFromPublishState(testGroupId, testGroupDataObj[testGroupId].expanded, UPDATE_ACTION.ARCHIVED);
                    });
                }

                let idx = 0;
                const testGroupIds = getSelectedTestAndGroupIdsByArchived(false).testGroupIds;
                testGroupIds.forEach((testGroupId) => {
                    archiveTestGroup(testGroupId, async () => {
                        if (idx === testGroupIds.length - 1 && FILTER_OPTIONS.ACTIVE.value === statusValue) {
                            const newData = testGroupData.filter((item) => !testGroupIds.includes(item.testGroupId));
                            setTestGroupData(newData);
                            setIsTableLoading(false);
                            setSingleSelected(false);
                            setMultipleSelected(false);
                            setArchiveOnly(false);
                            idx++;
                        } else {
                            const record = testGroupData.filter((row) => row.testGroupId === testGroupId)[0];
                            record.archived = true;
                            await reloadUpdateTestGroup();//wait for testGroup update before loading tests into it
                            refreshTestGroupFromPublishState(testGroupId, record.expanded, UPDATE_ACTION.ARCHIVED);
                        }
                    })
                });
            }).then(searchTestGroups).catch((error) => {
            console.error('Error archiving tests: ', error);
        }).finally(() => {
            setIsTableLoading(false);
        });
        // });
    }

    const unarchiveTestGroupsTests = () => {
        setIsTableLoading(() => {
            return true
        });
        if (FILTER_OPTIONS.ARCHIVED.value === statusValue) {
            setSelectedRowKeys(() => {
                return [];
            });
        }
        const ids = getSelectedTestAndGroupIdsByArchived(true),
            testIds = ids.testIds,
            testGroupIds = ids.testGroupIds;
        axios.post('/web/ui/test/unarchiveTests', null, {
            params: {
                testIds: testIds.toString(),
                testGroupIds: testGroupIds.toString()
            }
        })
            .then(response => {
                let postTestUnarchived = false;
                const testGroupRefreshIds = [];
                selectedRows.forEach((row) => {
                    if (row.type !== RECORDS.FAMILY.type && FILTER_OPTIONS.ACTIVE.value === statusValue) {
                        removeTestInTable(row);
                    } else {
                        if (row.testPurpose === TEST_TYPE.DIAGNOSTIC_POST_TEST) {
                            if (!postTestUnarchived) {
                                postTestUnarchived = true;
                                row.archived = false;
                                if (!testGroupRefreshIds.includes(row.testGroupId)) {
                                    testGroupRefreshIds.push(row.testGroupId);
                                }
                                testGroupDataObj[row.testGroupId].postTestGenerated = true;
                            }
                        } else {
                            if (!testGroupRefreshIds.includes(row.testGroupId)) {
                                testGroupRefreshIds.push(row.testGroupId);
                            }
                            row.archived = false
                        }
                    }
                });

                if (statusValue === FILTER_OPTIONS.ALL.value) {
                    testGroupRefreshIds.forEach((testGroupId) => {
                        refreshTestGroupFromPublishState(testGroupId, testGroupDataObj[testGroupId].expanded, UPDATE_ACTION.UNARCHIVED);
                        testGroupDataObj[testGroupId].archived = false;
                    });
                }
                let idx = 0;
                const testGroupIds = getSelectedTestAndGroupIdsByArchived(true).testGroupIds;
                testGroupIds.forEach((testGroupId) => {
                    unarchiveTestGroup(testGroupId, async () => {
                        if (idx === testGroupIds.length - 1 && FILTER_OPTIONS.ARCHIVED.value === statusValue) {
                            const newData = testGroupData.filter((item) => !testGroupIds.includes(item.testGroupId));
                            setTestGroupData(newData);
                            setIsTableLoading(false);
                            setSingleSelected(false);
                            setMultipleSelected(false);
                            setArchiveOnly(false);
                            idx++;
                        } else {
                            const record = testGroupData.filter((row) => row.testGroupId === testGroupId)[0];
                            record.archived = false;
                            await reloadUpdateTestGroup();//wait for testGroup update before loading tests into it
                            refreshTestGroupFromPublishState(testGroupId, record.expanded, UPDATE_ACTION.UNARCHIVED);
                        }
                    })
                });
            }).then(searchTestGroups).catch((error) => {
            console.error('Error unarchiving tests: ', error);
        }).finally(() => {
            setIsTableLoading(false);
        });
    }

    const getSelectedTestAndGroupIds = () => {
        const testIds = [],
            testGroupIds = [],
            mergedTestGroupIds = {};
        selectedRows.forEach((row) => {
            if (row.type !== RECORDS.SHARED.type) {
                if (row.type !== RECORDS.FAMILY.type) {
                    testIds.push(row.testId);
                } else {
                    testGroupIds.push(row.testGroupId);
                }
                mergedTestGroupIds[row.testGroupId + ''] = row.testGroupId;
            }
        });
        return {testIds: testIds, testGroupIds: testGroupIds, mergedTestGroupIds: mergedTestGroupIds};
    }

    const getSelectedTestAndGroupIdsByArchived = (archivedVal) => {
        const testIds = [],
            testGroupIds = [],
            mergedTestGroupIds = {};
        selectedRows.forEach((row) => {
            if (row.type !== RECORDS.SHARED.type && row.archived === archivedVal) {
                if (row.type !== RECORDS.FAMILY.type) {
                    testIds.push(row.testId);
                } else {
                    testGroupIds.push(row.testGroupId);
                }
                mergedTestGroupIds[row.testGroupId + ''] = row.testGroupId;
            }
        });
        return {testIds: testIds, testGroupIds: testGroupIds, mergedTestGroupIds: mergedTestGroupIds};
    }

    const onAssignTests = async () => {
        const fieldsValue = assignTestForm.getFieldsValue();

        if (isFormMissingValues(fieldsValue, ['messageForStudents']) || fieldsValue.classIds.length > 5) {
            assignTestForm.validateFields();
            return Promise.reject('Required fields are missing');
        } else {
            return getTestIdsFromTestGroups(async (testIds, testGroupIds) => {
                let params = {
                    classIds: fieldsValue.classIds,
                    all: true,
                    testType: fieldsValue.format,
                    note: fieldsValue.messageForStudents,
                    showResultsOnExpiry: fieldsValue.showResultsOnExpiry,
                    startDate: fieldsValue.startDate.format(user.getDateTimeFormatString()),
                    endDate: fieldsValue.endDate.format(user.getDateTimeFormatString())
                }

                if (RECIPIENT.SINGLE_CLASS.value === recipientState.value && fieldsValue.studentIds.length !== initialStudentIds.length) {
                    params.all = false;
                    params.studentsInClass = fieldsValue.studentIds;
                }

                if (testIds === null) {
                    displayToastMessage('No tests selected', '', 'error', undefined, 10000);
                    return Promise.reject('No tests selected');
                }
                params.testIds = testIds.toString();
                await assignTests(params, testGroupIds);
            });
        }
    }

    const assignTests = async (params, testGroupObjIds) => {
        setIsTableLoading(true);
        await axios.post('/controlCentre/assignTest.action', prepareAxiosParamsForStruts(params), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
            .then(response => {
                if (response.data.success) {
                    selectedRows.forEach((row) => {
                        if (row.type !== "Family") {
                            row.assigned = true;
                        }
                    });
                    Object.keys(testGroupObjIds).forEach((key) => {
                        const record = testGroupDataObj[key];
                        if (record.testIds !== undefined && record.children !== undefined && record.testIds.length > record.children.length) {
                            loadTestsInTestGroup(record, () => {
                                updateTestGroupTestData(record, params.testIds, UPDATE_ACTION.ASSIGNED);
                            });
                        } else {
                            updateTestGroupTestData(record, params.testIds, UPDATE_ACTION.ASSIGNED);
                        }
                    });
                    displayToastMessage('Test/s assigned successfully', response.data.message, 'success', undefined, 10000);
                    props.triggerTestAssignmentSearch();
                } else {
                    displayToastMessage('Error assigning test', response.data.message, 'error', undefined, 10000);
                }
            }).catch((error) => {
                console.error(error);
            }).finally(() => {
                setIsTableLoading(false);
                setAssignDialogOpen(false);
                assignTestForm.resetFields();
                setStudents([]);
                resetToDefaultRecipient();
            });
    }


    const addTestToGroup = (testGroup, newTestData, callback) => {
        const newData = modifyTestDataForTable([newTestData], testGroup.testGroupId)[0];
        const expandRowCallback = () => {
            expandRow(testGroup.testGroupId, newData);
            updateTestGroupTestData(testGroup);
            if (callback && typeof callback === 'function') {
                callback();
            }
        }
        if (testGroup.loadChildrenOnExpand) {
            loadTestsInTestGroup(testGroup, expandRowCallback);
        } else {
            expandRowCallback();
        }
    }

    const onPrintTest = async () => {
        printTestWithColumn(1, selectedSingleTest.testId);
        setPrintTestDialogOpen(false);
        return Promise.resolve();
    }

    const getTestAnswerKey = async () => {
        const params = getOpenWinParams(100, 100),
            testWin = window.open('/controlCentre/printMarkingKey.action' + '?testId=' + selectedSingleTest.testId, "testWindow", params);
        testWin.focus();
        setAnswerKeyDialogOpen(false);
        return Promise.resolve();
    }

    const handlePrintTest = () => {
        setPrintTestDialogOpen(true);
    }

    const handleAnswerKey = () => {
        setAnswerKeyDialogOpen(true);
    }

    const onPageChange = (pageVal) => {
        setCurrentPage(pageVal);
    }

    const onArchiveAll = async () => {
        if (archiveBeforeDate === null) {
            archiveAllForm.validateFields();
            return Promise.reject('Archive date is invalid');
        }
        await archiveTestGroupsBeforeDate();
    }

    const onChangeAddNow = ({target: {value}}) => {
        props.setUseEditWizard(!value);
        setAddQuestionsNow(value);

        const fieldValues = createPreTestForm.getFieldsValue();
        const ignoreFields = ['testDescription'];
        if (!value) {
            ignoreFields.push('useWizard');
        }
        if (isFormMissingValues(fieldValues, ignoreFields)) {
            createPreTestForm.validateFields();
        }
    }

    const onRowSelect = (record, selected, selectedRows, nativeEvent) => {
        setSelectedRows(selectedRows);
    }

    const onSelectAllRows = (select, selectedRows) => {
        setSelectedRows(selectedRows);
    }

    useEffect(() => {
        toggleEnableActions();
    }, [selectedRows]);

    useEffect(() => {
        if (isFilterActive) {
            const fields = filterForm.getFieldsValue();
            setFilterTemporary({
                status: fields.status,
                author: fields.author,
                showDateRange: showDateRange,
                dateRange: fields.dateRange
            });
        }
    }, [isFilterActive])

    const toggleEnableActions = () => {
        const testRows = [],
            testGroupRows = [];
        let postTest = false,
            onlyArchive = false,
            onlyUnarchive = false;

        setSelectedSingleTest({});

        selectedRows.forEach((row) => {
            if (row.type === RECORDS.FAMILY.type || row.type === RECORDS.SHARED.type) {
                testGroupRows.push(row);
            } else {
                testRows.push(row);
                if (row.type === RECORDS.POST.type) {
                    postTest = true;
                }
            }
        });

        if (testGroupRows.length > 1) {
            testGroupRows.forEach((testGroupRow) => {
                if (testGroupRow.totalTests === 0) {
                    onlyArchive = true;
                    onlyUnarchive = true;
                }
            });
            setSingleSelected(false);
            setMultipleSelected(true);
        } else if (testGroupRows.length === 1) {
            postTest = testGroupRows[0].postTestGenerated;
            if (testGroupRows[0].totalTests === 1) {
                if (testRows.length === 0) {
                    loadTestsInTestGroup(testGroupRows[0], () => {
                        setSelectedSingleTest(testGroupRows[0].children[0]);
                    });
                    setSingleSelected(true);
                    setMultipleSelected(false);
                } else if (testRows.length === 1 && testRows[0].testGroupId === testGroupRows[0].testGroupId) {
                    setSelectedSingleTest(testRows[0]);
                    setSingleSelected(true);
                    setMultipleSelected(false);
                } else {
                    setSingleSelected(false);
                    setMultipleSelected(true);
                }
            } else if (testGroupRows[0].totalTests === 0) {
                setSingleSelected(false);
                setMultipleSelected(false);
                if (testGroupRows[0].key !== RECORDS.SHARED.key) {
                    onlyArchive = true;
                    onlyUnarchive = true;
                }
            } else {
                setSingleSelected(false);
                setMultipleSelected(true);
            }
        } else if (testRows.length === 1) {
            setSelectedSingleTest(testRows[0]);
            setSingleSelected(true);
            setMultipleSelected(false);
        } else if (testRows.length > 1) {
            setSingleSelected(false);
            setMultipleSelected(true);
        } else {
            setSingleSelected(false);
            setMultipleSelected(false);
        }


        if (statusValue === FILTER_OPTIONS.ALL.value) {
            setSelectedRowsArchivable(selectedRows.some(item => {
                return !item.archived;
            }));

            setSelectedRowsUnarchivable(selectedRows.some(item => {
                return item.archived;
            }));
        } else if (statusValue === FILTER_OPTIONS.ACTIVE.value) {
            setSelectedRowsArchivable(selectedRows.some(item => {
                return !item.archived;
            }));
            setSelectedRowsUnarchivable(false);
        } else {
            setSelectedRowsUnarchivable(selectedRows.some(item => {
                return item.archived;
            }));
            setSelectedRowsArchivable(false);
        }

        setArchiveOnly(onlyArchive);
        setPostTestSelected(postTest);
        setSharedTestSelected(false);
    }

    const handleClassChange = value => {
        setClassIds(value);
    }

    const handleStudentChange = value => {
        setStudentIds(value);
    }

    const handleEditTestConfirm = () => {
        setTriggerEditTest(new Date().getTime());
        setEditTestDialogOpen(false);
        return Promise.resolve();
    }

    const handleSelectAllClassIds = event => {
        if (event.target.checked) {
            setClassIds(initialClassIds);
            assignTestForm.setFieldsValue({['classIds']: initialClassIds});
        } else {
            deselectAllClassSelect();
        }
    }

    const handleSelectAllStudentIds = event => {
        if (event.target.checked) {
            setStudentIds(initialStudentIds);
            assignTestForm.setFieldsValue({['studentIds']: initialStudentIds});
        } else {
            deselectAllStudentSelect();
        }
    }

    const deselectAllClassSelect = () => {
        assignTestForm.setFieldsValue({['classIds']: []});
        setClassIds([]);
    }

    const deselectAllStudentSelect = () => {
        assignTestForm.setFieldsValue({['studentIds']: []});
        setStudentIds([]);
    }
    const onShowDateRangeChange = (checked) => {
            setShowDateRange(checked);
    }
    const handleAssignTest = () => {
        const showDialog = checkSelectedTestsHaveQuestions();
        setAssignDialogOpen(showDialog);
        if (!showDialog) {
            displayToastMessage('Can not assign test/s', 'Test/s must have questions to be assigned', 'warning', null, 10000);
        }
    }

    const handleShareTest = () => {
        const showDialog = checkSelectedTestsHaveQuestions();
        setShareDialogOpen(showDialog);
        if (!showDialog) {
            displayToastMessage('Can not share test/s', 'Test/s must have questions to be shared', 'warning', null, 10000);
        }
    }

    const openShareTestFamilyDialog = (record) => {
        setShareTestFamilyId(record.testGroupId);
        setShareTestFamilyName(record.testGroupName);
        setShareTestFamilyDialogOpen(true);
    }

    useEffect(()=>{
        if(isShareDialogOpen){
            getTestIdsFromTestGroups((retrievedTestIds) => {
                if (retrievedTestIds === null) {
                    displayToastMessage('No tests selected', '', 'error', undefined, 10000);
                } else {
                    setSharedTestIds(retrievedTestIds);
                }
            });
        }
    },[isShareDialogOpen]);

    const onEditTestRadioChange = ({target: {value}}) => {
        props.setUseEditWizard(value);
    }

    const checkSelectedTestsHaveQuestions = () => {
        let showDialog = true;
        for (let i = 0; i < selectedRows.length; i++) {
            const row = selectedRows[i];
            if (row.type === RECORDS.FAMILY.type && !row.allTestsHaveQuestions) {
                showDialog = false;
                break;
            } else if (row.total === 0) {
                showDialog = false;
                break;
            }
        }
        return showDialog;
    }

    const handleCancel = () => {
        filterForm.setFieldsValue({['status']: filterTemporary.status});
        filterForm.setFieldsValue({['author']: filterTemporary.author});
        filterForm.setFieldsValue({['dateRange']: filterTemporary.dateRange});
            setShowDateRange(filterTemporary.showDateRange);
        setFilterActive(false);
    }

    const applyFilter = () => {
        const fieldValues = filterForm.getFieldsValue();
        const params = {...searchParams};

        if (Object.keys(fieldValues).length > 0) {
            params.publishStates = FILTER_OPTIONS[fieldValues.status].publishStates;
            params.meAuthor = FILTER_OPTIONS[fieldValues.author].meAuthor;
            params.allAuthor = FILTER_OPTIONS[fieldValues.author].allAuthor;

            if (showDateRange) {
                if (fieldValues.dateRange === undefined || !fieldValues.dateRange[0] || !fieldValues.dateRange[1]) {
                    filterForm.validateFields();
                    return;
                }

                params.startDateStr = fieldValues.dateRange[0].format(user.getDateFormatString());
                params.endDateStr = fieldValues.dateRange[1].format(user.getDateFormatString());
            } else {
                delete params.startDateStr;
                delete params.endDateStr;
            }
        } else {
            params.meAuthor = FILTER_OPTIONS['ME'].meAuthor;
            params.allAuthor = FILTER_OPTIONS['ME'].allAuthor;
        }

        if (searchValue !== '') {
            params.testName = params.name = params.description = searchValue;
        } else {
            delete params.testName;
            delete params.name;
            delete params.description;
        }

        setSearchParams(params);
        setFilterActive(false);
        setStatusValue(fieldValues.status);
    }

    useEffect(() => {
        setSelectedRowKeys([]);
    }, [statusValue]);

    const onFormatChange = ({target: {value}}) => {
        setFormatValue(value);
    }

    const onRecipientChange = ({target: {value}}) => {
        let setVal = [],
            classVal = assignTestForm.getFieldValue('classIds');

        if (value === RECIPIENT.MULTIPLE_CLASSES.value) {
            if (classVal !== undefined && !Array.isArray(classVal)) {
                setVal = [classVal];
            }
            setRecipientState({...RECIPIENT.MULTIPLE_CLASSES});
        } else {
            if (classVal && classVal.length === 1 && classVal[0]) {
                setVal = classVal[0];
                getStudentsInClass(classVal[0]);
            } else {
                setVal = undefined;
                resetStudentDropDown();
            }
            setRecipientState({...RECIPIENT.SINGLE_CLASS});
        }
        assignTestForm.setFieldValue('classIds', setVal);
        setClassIds(setVal);
    }

    const onClassChange = (value) => {
        if (recipientState.value === RECIPIENT.SINGLE_CLASS.value) {
            if (value) {
                getStudentsInClass(value);
            } else {
                resetStudentDropDown();
            }
        }
    }

    const resetStudentDropDown = () => {
        setStudents([])
        setStudentIds([]);
        setInitialStudentIds([]);
        assignTestForm.setFieldsValue({['studentIds']: []});
    }

    const getStudentsInClass = (classId) => {
        axios.get('/web/ui/sc/studentsInClass', {params: {classId: classId}})
            .then(response => {
                if (response.data) {
                    const studentsData = response.data;
                    setStudents(studentsData);
                    const ids = [];
                    studentsData.forEach(student => {
                        ids.push(student.userId);
                    });
                    setStudentIds(ids);
                    setInitialStudentIds(ids);
                    assignTestForm.setFieldsValue({['studentIds']: ids});
                }
            }).catch(error => {
            console.error('Error loading students. ', error);
        });

    }

    const onChangeStartDate = (value) => {
        setStartDate(value)
    }

    const resetToDefaultRecipient = ()=>{
        setRecipientState({...DEFAULT_RECIPIENT});
    }

    const searchSharedTestsPaged = useCallback((params, handleTableData, handlePagingData, abortController) => {
        const {pageSize = 5, pageNumber = 1, sharedSearchParams} = params;
        axios.post('/web/ui/test/loadSharedTestGroup', sharedSearchParams, {headers: {
                'Content-Type': 'application/json'
            },
            params: {
                pageSize: pageSize,
                pageNumber: pageNumber
            }, signal: abortController.signal
        }).then(response => {
            if (response && response.data) {
                handleTableData(modifyTestDataForTable(response.data.currPageContents));
                const {pageSize, totalResults} = response.data;
                let {currPage} = response.data.currPage;
                setSharedTestsTotal(totalResults);
                setCurrentPageSharedTestIds(response.data.currPageContents.map(rowData => rowData.testId));
                handlePagingData({currPage, pageSize, totalResults});
            }
        }).catch((error) => {
            if(!isCancel(error)){
                console.error('Missing params values for searchSharedTests.');
                displayToastMessage('Error finding shared tests', error.response.data.message, 'error', undefined, 10000);
            }
        }).finally(()=>{
            abortController = null;
        });
        // }
    },[]);

    return (
        <>
            {isMainLoading && <div style={{padding: '8px'}}><CircularLoader/></div>}
            {!isMainLoading &&
                <div id={'teacherTestGroups'}>
                    <div id="testGroupTopActionBar">
                        <div>
                            <div className="searchButtonWrapper" style={{display: 'flex', alignItems: 'center'}}>
                                <Input id="searchTestGroupInput" onChange={({target: {value}}) => {
                                    setSearchValue(value)
                                }} placeholder="Search by name or description"/>
                                <TooltipMUI enterDelay={1000} placement={"top"} title="Search and apply filters"
                                            children={<Button style={{height: '32px'}} size="small"
                                                              onClick={applyFilter}><Search/></Button>}/>
                                {/*<span style={{width:'100%'}}>{searchMessage + ' ('+testGroupData.length+')'}</span>*/}
                                {/*<Input style={{minWidth:'220px'}} placeholder={'Search by name or description'}/>*/}
                                {/*<Button size="ch-btn-small" style={{width:'48px', minWidth:'unset'}} onClick={searchTestGroups}><Search/></Button>*/}
                            </div>
                            <div style={{position: 'relative'}}>
                                <div className={"flexRow mediumGap"}>
                                    <TooltipMUI enterDelay={1000} placement={"top"} title="Toggle filter options"
                                                children={<Button id="toggleFilterButton" size="small"
                                                                  style={{minWidth: 'unset', width: '40px'}}
                                                                  activated={isFilterActive} onClick={() => {
                                                    setFilterActive((prevState) => {
                                                        if (prevState) {
                                                            handleCancel()
                                                        }
                                                        return !prevState
                                                    })
                                                }}><FilterList/></Button>}/>
                                    {/*<div className={'flex flexAlignCentre'}>*/}
                                    {/*    <span className={'ch-bold'}>Filters:</span>*/}
                                    {/*    <Button style={{pointerEvents:"none"}} size={'small'} type={'outline'} activated={true}>Status: {statusFilter}</Button>*/}
                                    {/*</div>*/}
                                </div>
                                {isFilterActive &&
                                    <div id="filterForm">
                                        <h4>Test Family Filter</h4>
                                        <Form
                                            form={filterForm}
                                            labelCol={{
                                                span: 24
                                            }}
                                            initialValues={{
                                                status: FILTER_OPTIONS.ACTIVE.value,
                                                author: FILTER_OPTIONS.ME.value
                                            }}>
                                            <Form.Item
                                                label="Status"
                                                name="status"
                                                // required={true}
                                            >
                                                <Radio.Group
                                                    optionType="button"
                                                    size="small"
                                                    options={[
                                                        {
                                                            label: FILTER_OPTIONS.ALL.label,
                                                            value: FILTER_OPTIONS.ALL.value
                                                        },
                                                        {
                                                            label: FILTER_OPTIONS.ACTIVE.label,
                                                            value: FILTER_OPTIONS.ACTIVE.value
                                                        },
                                                        {
                                                            label: FILTER_OPTIONS.ARCHIVED.label,
                                                            value: FILTER_OPTIONS.ARCHIVED.value
                                                        }
                                                    ]}/>
                                            </Form.Item>
                                            <Form.Item label="Author"
                                                       name="author"
                                                // required={true}
                                            >
                                                <Radio.Group
                                                    optionType="button"
                                                    size="small"
                                                    options={[
                                                        {
                                                            label: FILTER_OPTIONS.ME.label,
                                                            value: FILTER_OPTIONS.ME.value
                                                        },
                                                        {
                                                            label: FILTER_OPTIONS.SCHOOL.label,
                                                            value: FILTER_OPTIONS.ALL.value
                                                        },
                                                        {
                                                            label: FILTER_OPTIONS.SHARED.label,
                                                            value: FILTER_OPTIONS.SHARED.value
                                                        }]
                                                    }/>
                                            </Form.Item>
                                            <div className={'flexAlignCentre smallGap'} style={{borderBottom:'1px solid lightgrey'}}><span>Date range</span><Switch
                                                style={{height:'16px',width:'32px'}}
                                                checked={showDateRange}
                                                size={'small'}
                                                onChange={onShowDateRangeChange}
                                                />
                                                </div>
                                            <Form.Item
                                                name={"dateRange"}
                                                labelCol={{
                                                    span: 6
                                                }}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please select start and end date.',
                                                    }
                                                ]}
                                            >
                                                <RangePicker
                                                    disabled={!showDateRange}
                                                    placement="topLeft"
                                                    format={user.getDateFormatString()}
                                                />
                                            </Form.Item>
                                        </Form>
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'flex-end',
                                            gap: '4px',
                                            marginTop: '6px'
                                        }}>
                                            <Button onClick={handleCancel} type={'text'}>Cancel</Button>
                                            <TooltipMUI enterDelay={1000} placement={"top"}
                                                        title="Search and apply filters"
                                                        children={<Button onClick={applyFilter}>Apply</Button>}/>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <div>
                            <Tooltip trigger={['hover', 'focus']} title={MAIN_HELP_TOOLTIP} placement="left">
                                <HelpIcon tabIndex={0} sx={{m: 1}} style={{
                                    verticalAlign: 'middle',
                                    marginLeft: '4px',
                                    width: '24px',
                                    height: '24px'
                                }}/>
                            </Tooltip>
                        </div>
                    </div>
                    <h2 style={{
                        width: '100%',
                        padding: '10px 4px'
                    }}>{tableHeading + ' (' + testGroupData.length + ')'}</h2>
                    <div>
                        <TableAntD className="ch-general-table-antd rounded"
                            pagination={{
                                defaultCurrent: 1,
                                current: currentPage,
                                onChange: onPageChange,
                                pageSize: pageSize
                            }}
                               rowSelection={{
                                   selectedRowKeys, checkStrictly: false,
                                   onChange: onSelectChange, onSelect: onRowSelect, onSelectAll: onSelectAllRows,
                                   getCheckboxProps: (record) => ({
                                       // disabled: record.archived,
                                       // Column configuration not to be checked
                                       name: record.name,
                                   })
                               }}

                               onExpand={(e, record) => {
                                   onTestGroupExpand(record)
                               }}
                               expandedRowKeys={expandedRowKeys}
                               expandable={{
                                   expandIcon: ({expanded, onExpand, record}) =>
                                       (record.type === RECORDS.FAMILY.type || record.type === RECORDS.SHARED.type) && record.totalTests === 0 ? (
                                               <Tooltip
                                                   title={record.type === RECORDS.FAMILY.type ? NO_TEST_CREATED_YET_TOOLTIP : NO_SHARED_TESTS_YET}>
                                                   <ErrorOutline/></Tooltip>
                                           ) :
                                           ((record.type === RECORDS.FAMILY.type || record.type === RECORDS.SHARED.type) ? (expanded ? (
                                               <ExpandLess onClick={e => onExpand(record, e)}/>
                                           ) : (
                                               <ExpandMore onClick={e => onExpand(record, e)}/>
                                           )) : <></>),
                               }}
                               size={'small'}
                               columns={testGroupColumns}
                               dataSource={testGroupData}
                               loading={isTableLoading}
                               rowClassName={() => 'editable-row'}
                               components={{
                                   body: {
                                       row: EditableRow,
                                       cell: EditableCell
                                   },
                               }}
                        />
                    </div>
                    <div className={'flexSpaceBetween flexWrap'}>
                        <div className={'flexWrap button-group'}>
                            <Button onClick={openCreateTestGroupDialog}>+ Test family</Button>
                            <Button type={BUTTON_TYPE.OUTLINE}
                                    onClick={handleAssignTest}
                                    disabled={(!(multipleSelected || singleSelected)) || archiveOnly || sharedTestSelected}>Assign</Button>
                            <Button
                                type={BUTTON_TYPE.OUTLINE}
                                onClick={() => {
                                setCopyDialogOpen(true);
                            }} disabled={(!(singleSelected && !multipleSelected) || postTestSelected)}>{sharedTestSelected ? 'Copy or move' : 'Copy'}</Button>
                            <Button type={BUTTON_TYPE.OUTLINE}
                                    onClick={handleShareTest}
                                    disabled={(!(multipleSelected || singleSelected)) || archiveOnly || postTestSelected}>Share</Button>
                            {((FILTER_OPTIONS.ALL.value === statusValue || FILTER_OPTIONS.ACTIVE.value === statusValue)) &&
                                <PopConfirm title={<span>Archive selected rows?</span>}
                                            description={ARCHIVE_TEST_GROUP_WARNING}
                                            okText='Archive'
                                            onConfirm={() => archiveTests()}>
                                    <Button
                                        type={BUTTON_TYPE.OUTLINE}
                                        disabled={(!(multipleSelected || singleSelected || archiveOnly) || !selectedRowsArchivable)}>Archive</Button>
                                </PopConfirm>
                            }
                            {((FILTER_OPTIONS.ALL.value === statusValue || FILTER_OPTIONS.ARCHIVED.value === statusValue)) &&
                                <PopConfirm title={<span>Unarchive selected rows?</span>}
                                            description={UNARCHIVE_TEST_GROUP_WARNING}
                                            okText='Unarchive'
                                            onConfirm={() => unarchiveTestGroupsTests()}>
                                    <Button
                                        type={BUTTON_TYPE.OUTLINE}
                                        disabled={(!(multipleSelected || singleSelected || archiveOnly) || !selectedRowsUnarchivable)}>Unarchive</Button>
                                </PopConfirm>
                            }
                            <Button type={BUTTON_TYPE.OUTLINE}
                                    onClick={handlePrintTest}
                                    disabled={!(singleSelected && !multipleSelected)}>Print</Button>
                            <Button type={BUTTON_TYPE.OUTLINE}
                                    onClick={handleAnswerKey} disabled={!(singleSelected && !multipleSelected)}>Answer
                                key</Button>
                            {FILTER_OPTIONS.ARCHIVED.value !== statusValue && <Button
                                type={BUTTON_TYPE.OUTLINE}
                                onClick={() => {
                                setArchiveAllDialogOpen(true)
                            }} disabled={testGroupData.length === 0}>Archive all</Button>}
                        </div>
                        {/* Testing Button */}
                        {/*{testGroupData.length > 4 && <div>*/}
                        {/*    <a tabIndex={0} className={'ch-link'} onClick={()=>{setCurrentPage(Math.floor((testGroupData.length+1)/5))}}>{`Go to last page for shared ${brandConfig.diagnosticName}s`}</a>*/}
                        {/*</div>}*/}
                    </div>
                    <Divider/>
                    <h2 style={{
                        width: '100%',
                        padding: '10px 4px'
                    }}>{'Shared tests (' + sharedTestsTotal  + ')'}</h2>
                    <div>
                        <TableAntD id="testAssignmentsFollowUp"
                                  pagingDependencies={[triggerShareTestReload]}
                                  pagingData={{fetchFunction:searchSharedTestsPaged, params:{sharedSearchParams:sharedSearchParams}}}
                                  columnData={sharedTestColumns}
                                  // reload={reloadShareTestTable}
                                  // loading={isShareTestTableLoading}
                        />
                    </div>
                    <CreateTestGroupDialog
                        open={isCreateTestGroupDialogOpen}
                        onClose={() => setCreateTestGroupDialogOpen(false)}
                        createTestGroupForm={createTestGroupForm}
                        onCreateTestGroup={onCreateTestGroup}
                    />
                    <CreatePreTestDialog
                        open={isCreatePreTestDialogOpen}
                        onClose={() => setCreatePreTestDialogOpen(false)}
                        createPreTestForm={createPreTestForm}
                        addQuestionsNow={addQuestionsNow}
                        onChangeAddNow={onChangeAddNow}
                        onCreatePreTest={onCreatePreTest}
                        createTestDescription={createTestDescription}
                    />
                    <CreatePostTestDialog
                        open={isCreatePostTestDialogOpen}
                        onClose={() => setCreatePostTestDialogOpen(false)}
                        createPostTestForm={createPostTestForm}
                        onCreatePostTest={onCreatePostTest}
                        GENERATE_POST_TEST_WARNING={GENERATE_POST_TEST_WARNING}
                    />
                    <CopyDiagnosticTestsDialog
                        sharedTest={sharedTestSelected}
                        open={isCopyDialogOpen}
                        onClose={() => {
                                setCopyDialogOpen(false);
                                setSelectedRows([]);
                                setSelectedRowKeys([]);
                            }
                        }
                        selectedSingleTest={selectedSingleTest}
                        testGroupData={testGroupData}
                        addTestToGroup={addTestToGroup}
                        setIsTableLoading={setIsTableLoading}
                        handleReloadSharedTests={reloadShareTestTable}
                    />
                    <PrintTestDialog
                        open={isPrintTestDialogOpen}
                        onClose={() => setPrintTestDialogOpen(false)}
                        onPrintTest={onPrintTest}
                        selectedSingleTest={selectedSingleTest}
                    />
                    <AnswerKeyDialog
                        open={isAnswerKeyDialogOpen}
                        onClose={() => setAnswerKeyDialogOpen(false)}
                        onPrintAnswerKey={getTestAnswerKey}
                        selectedSingleTest={selectedSingleTest}
                    />
                    <ArchiveAllDialog
                        open={isArchiveAllDialogOpen}
                        onClose={() => setArchiveAllDialogOpen(false)}
                        archiveAllForm={archiveAllForm}
                        onArchiveAll={onArchiveAll}
                        handleSetArchiveDate={setArchiveBeforeDate}
                        archiveDateBefore={archiveBeforeDate}
                        user={user}
                    />
                    <AssignDiagnosticTestDialog
                        open={isAssignDialogOpen}
                        onClose={() => {
                            setAssignDialogOpen(false);
                        }}
                        onAssignTests={onAssignTests} // your function
                        assignTestForm={assignTestForm}
                        editAssignObj={editAssignObj}
                        recipientState={recipientState}
                        setRecipientState={setRecipientState}
                        classIds={classIds}
                        setClassIds={setClassIds}
                        studentIds={studentIds}
                        setStudentIds={setStudentIds}
                        students={students}
                        setStudents={setStudents}
                        initialStudentIds={initialStudentIds}
                        initialClassIds={initialClassIds}
                        user={user}
                        openDialogDate={openDialogDate}
                        startDate={startDate}
                        onChangeStartDate={onChangeStartDate}
                        onFormatChange={onFormatChange}
                        onRecipientChange={onRecipientChange}
                        onClassChange={onClassChange}
                        handleClassChange={handleClassChange}
                        handleStudentChange={handleStudentChange}
                        handleSelectAllClassIds={handleSelectAllClassIds}
                        handleSelectAllStudentIds={handleSelectAllStudentIds}
                        initialRecipientValue={DEFAULT_RECIPIENT.value}
                    />
                    <ShareTestsDialog
                        open={isShareDialogOpen}
                        handleDialogOpen={(val)=>{setShareDialogOpen(val)}}
                        testIds={sharedTestIds}
                        testName={brandConfig.diagnosticName}
                        testsName={brandConfig.diagnosticsName}
                    />
                    <ShareTestFamilyDialog
                        open={isShareTestFamilyDialogOpen}
                        handleDialogOpen={(val)=>{setShareTestFamilyDialogOpen(val)}}
                        testFamilyId={shareTestFamilyId}
                        testFamilyName={shareTestFamilyName}
                        testName={brandConfig.diagnosticName}
                        testsName={brandConfig.diagnosticsName}
                    />
                    <EditTestDialog
                        open={isEditTestDialogOpen}
                        onClose={() => setEditTestDialogOpen(false)}
                        useWizardForm={useWizardForm}
                        onEditTestConfirm={handleEditTestConfirm}
                        onEditTestRadioChange={onEditTestRadioChange}
                        defaultUseWizard={true}
                    />
                    <PreviewTestDialog
                        open={isViewTestDialogOpen}
                        onClose={() => setViewTestDialogOpen(false)}
                        testId={viewTestId}
                    />
                    <GenericDialog
                        title={DELETE_ALL_SHARED_TESTS_FOREVER_TOOLTIP}
                        open={showDeleteAllForeverDialog}
                        onClose={() => {setShowDeleteAllForeverDialog(false)}} // using dialog, as Popconfirm was throwing errors in the title.
                        buttons={[
                            {name: 'Cancel', extraProps: {type: 'text'}},
                            {name: <div className={'flexAlignCentre smallGap'}>Delete all<DeleteSweep
                                    style={{cursor: 'pointer', fontSize: '24px', color:'white'}}/></div>,
                            callback:handleArchiveAllSharedTest}
                        ]}>
                        Archive shared tests on the current page?
                    </GenericDialog>
                </div>
            }
        </>
    )
}
export default TestGroups;
